import { validateEmailAddress, validateFirstName, validateLastName, validatePhoneNumber } from '../../validation';
export var emailAddress = {
  name: 'emailAddress',
  type: 'string',
  sensitive: true,
  maxLength: 512,
  validators: [validateEmailAddress],
  viewConfig: {
    placeholder: 'email@email.com',
    skipFormatPlaceholder: true
  }
};
export var firstName = {
  name: 'firstName',
  type: 'string',
  format: 'alphabet',
  maxLength: 30,
  sensitive: true,
  validators: [validateFirstName],
  viewConfig: {
    placeholder: 'Your first name',
    skipFormatPlaceholder: true
  }
};
export var lastName = {
  name: 'lastName',
  type: 'string',
  format: 'alphabet',
  maxLength: 30,
  sensitive: true,
  validators: [validateLastName],
  viewConfig: {
    placeholder: 'Your last name',
    skipFormatPlaceholder: true
  }
};
export var leadMessage = {
  name: 'leadMessage',
  type: 'string',
  required: false,
  sensitive: true,
  maxLength: 1024,
  viewConfig: {
    viewType: 'textarea',
    placeholder: 'First home? Building your credit? Tell the lender a little more about your situation.'
  }
};
export var phoneNumber = {
  name: 'phoneNumber',
  type: 'string',
  sensitive: true,
  validators: [validatePhoneNumber],
  format: 'phoneNumber',
  viewConfig: {
    type: 'tel',
    placeholder: '(999) 999-9999'
  }
};